import React from 'react';
import { PrinterOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';
import message from '~/utils/message';
import httpClient from '~/http/services/pos';
import { PrintResponse } from '~/types/printer';

const TestPrintButton = () => {
  const { isReady, print } = usePrinter();

  const onClick = async () => {
    try {
      await print(({ printMethod, printerId }) => {
        return httpClient.post<PrintResponse>('/api/v2/printers/tests', {
          printMethod,
          printerId,
        });
      });
      message.success('Test print selesai');
    } catch (e: any) {
      message.error('Gagal test print: ' + e.message);
    }
  };

  return (
    <Button size="large" disabled={!isReady} onClick={onClick}>
      <div className="flex gap-1 items-center justify-center">
        <PrinterOutlined />
        <span>Test Print</span>
      </div>
    </Button>
  );
};

export default TestPrintButton;
